import usePublicConfig from "storefront/hooks/usePublicConfig";

const useListingStyles = () => {
  const { styles } = usePublicConfig();

  return styles.reduce<Record<string, typeof styles[0]>>((acc, style) => {
    acc[style.name] = style;
    return acc;
  }, {});
};

export default useListingStyles;
